import { StatState, StatActions, SYNC_STATS } from "../types";


const initialState: StatState = {
  uploadSpeed: 0,
  downloadSpeed: 0,
}


// const applyObjectDiff = (oldState: any, diff: Stat): any => {
//   const newState = { ...oldState };
//   if (diff.removed) {
//     diff.removed.forEach(key => delete newState[key])
//   }
//   if (diff.updated) {
//     for (const [ key, value ] of Object.entries(diff.updated)) {
//       const v = value as any;
//       if (key === 'torrents' && typeof(value) === 'object' && value && (v.updated || v.removed)) {
//         newState[key] = applyObjectDiff(newState.torrents, v);
//       } else {
//         newState[key] = value;
//       }
//     }
//   }
//   return newState;
// }


export default function statReducer(state = initialState, action: StatActions): StatState {
  switch (action.type) {
    case SYNC_STATS:
      return {
        ...state,
        ...action.stat
      }
    default:
      return state;
  }
}